import { queryOptions } from '@tanstack/vue-query'
import { HTTPError } from 'ky'
import { unref, type MaybeRef } from 'vue'
import { getChat } from '../api/get-chat'
import { personalChatsQueryOptions } from '../state/personal-chats-query'
import { publicChatsQueryOptions } from '../state/public-chats-query'

export const getChatQueryKey = (chatId: MaybeRef<number>) => ['chats', chatId]

export const getChatQueryOptions = (chatId: MaybeRef<number>) =>
  queryOptions({
    queryKey: getChatQueryKey(chatId),
    queryFn: async ({ client }) => {
      const publicChatsQueryData = client.getQueryData(publicChatsQueryOptions.queryKey)
      const personalChatsQueryData = client.getQueryData(personalChatsQueryOptions.queryKey)

      const allChats = [
        ...(publicChatsQueryData?.data ?? []),
        ...(personalChatsQueryData?.pages.flatMap(page => page.data) ?? []),
      ]

      const chat = allChats.find(chat => chat.id === unref(chatId))

      if (chat) return chat

      try {
        const chatResponse = await getChat(unref(chatId))
        return chatResponse.data
      } catch (error: unknown) {
        if (error instanceof HTTPError) {
          if (error.response.status === 404) {
            return null
          }
        }

        throw error
      }
    },
  })
